"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_es_1 = require("./messages_es");
var messages_cat_1 = require("./messages_cat");
exports.config = {
    env: ENVIRONMENT,
    backendHost: BACKENDHOST,
    backendPoint: BACKENDHOST + "/Wizards/submit&queue=false",
    context: {
        defaultCountryCode: "ES",
        channelId: "57480a2255d1055977a8a84b",
        processDefinitionId: "cbd033f92c4a2d319b82e3c8",
        urlOk: "http://www.solucionesintegralesendesa.com/solar-fotovoltaica#formulario_ok",
        domainId: "5719f8f025de438b6d301807",
    },
    formMessages: {
        es: messages_es_1.messages_es,
        cat: messages_cat_1.messages_cat,
    },
    provinces: [
        "Araba/Álava",
        "Albacete",
        "Alicante/Alacant",
        "Almería",
        "Ávila",
        "Badajoz",
        "Balears, Illes",
        "Barcelona",
        "Burgos",
        "Cáceres",
        "Cádiz",
        "Castellón/Castelló",
        "Ciudad Real",
        "Córdoba",
        "Coruña, La",
        "Cuenca",
        "Girona",
        "Granada",
        "Guadalajara",
        "Gipuzkoa",
        "Huelva",
        "Huesca",
        "Jaén",
        "León",
        "Lleida",
        "Rioja, La",
        "Lugo",
        "Madrid",
        "Málaga",
        "Murcia",
        "Navarra",
        "Ourense",
        "Asturias",
        "Palencia",
        "Palmas, Las",
        "Pontevedra",
        "Salamanca",
        "Santa Cruz de Tenerife",
        "Cantabria",
        "Segovia",
        "Sevilla",
        "Soria",
        "Tarragona",
        "Teruel",
        "Toledo",
        "Valencia/València",
        "Valladolid",
        "Bizkaia",
        "Zamora",
        "Zaragoza",
        "Ceuta",
        "Melilla",
    ],
};
